import React, { useEffect, useState } from 'react';
import './FileSearch.scss';
import { Button, Card, Col, Container, Form, Row } from 'react-bootstrap';
import Search from 'react-ionicons/lib/Search';
import FileExplorer, { FilePreview } from '../../components/FileExplorer';
import { T } from '../../helpers/Language';
import FolderPictureURL from '../../assets/img/draw-kit/folder_2.svg';
import CommentFallbackURL from '../../assets/img/draw-kit/social_feed.svg';
import InformationFallbackURL from '../../assets/img/draw-kit/configuration.svg';
import MainLayout from '../../layouts/MainLayout';
import * as DriveHelper from '../../helpers/Drive';
import { Drive as DriveAPI } from '../../api';
import AppTab from '../../components/AppTab/AppTab';
import FileComments from '../../components/FileExplorer/FileComment';
import FileInformation from '../../components/FileExplorer/FileInformation';
import { useNavigate } from 'react-router';
import UserAnalytic from '../../helpers/UserAnalytic';

export const DFLT_ICO_PROPS = {
    height: '28px',
    width: '28px',
    color: 'inherit'
};

export const FILE_EXTENSIONS_PREVIWABLE = [
    ".jpeg",
    ".jpg",
    ".png",
    ".gif",
    ".tiff",
    ".pdf"
];

const getAvailableYears = (currentYear) => {
    const result = [];
    for (let i = currentYear - 3; i <= currentYear; i++) {
        result.push({value: i, label: i});
    }
    return result;
}

const getAvailableMonths = () => {
    const monthNames = [
        "January", 
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ];

    const result = [];
    for (let i = 0; i <= 11; i++) {
        result.push({value: i, label: monthNames[i]})
    }
    return result;
}

const FileSearch = () => {
    // currentFiscalYear
    const currentYear = new Date().getFullYear() - 1;
    const availableYears = getAvailableYears(currentYear);
    const availableMonths = getAvailableMonths();
    const [searchResult, setSearchResult] = useState({});
    const [querySearch, setQuerySearch] = useState('');
    const [currentFile, setCurrentFile] = useState(null);
    const [isInitialize, setInitializeStatus] = useState(false);
    const [isLoading, setLoadingStatus] = useState(true);
    const [selectedYear, setSelectedYear] = useState("");
    const [selectedMonth, setSelectedMonth] = useState("");
    const [selectedDocumentType, setSelectedDocumentType] = useState("");
    const [documentTypes, setDocumentTypes] = useState({});
    const navigateManager = useNavigate();

    useEffect(() => {
        async function init() {
            await getDocumentTypes();
            await onSearch();
            setInitializeStatus(true);
        }

        if (!isInitialize) {
            setLoadingStatus(false);
            init();
        };
    }, [isInitialize]);

    const handleSubmit = (e) => {
        if (e) {
            e.preventDefault();
        }
        onSearch();
    }
    
    const handleYearChange = (event) => {
        const { value } = event.target;
        setSelectedYear(value);
    }

    const handleMonthChange = (event) => {
        const { value } = event.target;
        setSelectedMonth(value);
    }
    
    const handleDocumentTypeChange = (event) => {
        const { value } = event.target;
        setSelectedDocumentType(value);
    }

    const getDocumentTypes = async () => {
        try {
            const documentTypes = await DriveAPI.getDocumentTypes();
            setDocumentTypes(documentTypes);
        } catch (err) {}
    }

    const onSearch = async () => {
        setLoadingStatus(true);
        let fileOptReview = {
            query: querySearch,
            status: "REVIEW",
        }
        let fileOpt = {
            query: querySearch,
        }

        if (selectedYear !== '') {
            fileOptReview['year'] = selectedYear;
            fileOpt['year'] = selectedYear;
        }
        if (selectedMonth !== '') {
            fileOptReview['Month'] = selectedMonth;
            fileOpt['Month'] = selectedMonth;
        }
        if (selectedDocumentType !== '') {
            fileOptReview['documentType'] = selectedDocumentType;
            fileOpt['documentType'] = selectedDocumentType;
        }

        try {
            const { data: fileData } = await DriveAPI.searchFiles(fileOpt);
            const { data: fileDataReview } = await DriveAPI.searchFiles(fileOptReview);
            const data = [...fileData.file, ...fileDataReview.file];
            data.sort(function (a, b) {
                return new Date(b.updatedAt) - new Date(a.updatedAt);
            });
            // create map of files, we need to gather file info for preview.
            const map = {};
            for (const file of data) {
                map[file.id] = file;
            }
            setSearchResult(map);
            UserAnalytic.event({
                category: 'drive_explorer',
                action: 'Search file',
                label: `Get files`
            });
        } catch (e) {}
        setLoadingStatus(false);
    }

    const handleDownloadFile = (e) => {
        if (e && e.preventDefault) {
            e.preventDefault();
            e.stopPropagation();
            e.target.blur();
        }
        const url = DriveAPI.downloadFileHardLink(currentFile.id) + '&download=1';
        window.open(url, '__blank', 'noopener noreferrer');
    };

    const onSelectFile = async (fileId, forceReload = false) => {
        if (!fileId) return;
        if (forceReload === false && currentFile && currentFile.id === fileId) return;
        UserAnalytic.event({
            category: 'driver_explorer',
            action: 'Select file',
            label: `Select files ${fileId}`
        });
        const fileFromMap = searchResult[fileId];
        setCurrentFile({
            id: fileId,
            fileExtension: fileFromMap.fileExtension,
            _isDraft: true,
            _isFetching: true
        });
        try {
            const { data } = await DriveAPI.getFileInformation(fileId);
            data._isFetching = false;
            data._isDraft = false;
            setCurrentFile({
                ...data,
                comments: data.comments.sort(DriveHelper.Sort.byCreatedAt)
            });
        } catch (e) {
            console.log('error when downloading file');
        }
    };

    const onSendComment = async (comment) => {
        setLoadingStatus(true);
        try {
            const data = await DriveAPI.addCommentToFile(currentFile.id, comment);
            await onSelectFile(currentFile.id, true);
        } catch (e) {
        }
        setLoadingStatus(false);
    }

    return (
        <MainLayout pageTitle={T('DRIVE_FEXPLORER_TITLE_SEARCH_FILE')}>
            <Container fluid className="drive-search-page">
                <Row className="mt-2">
                    <Col lg={12}>
                        <Button onClick={() => navigateManager('/documents')}>{T('GEN_BACK')}</Button>
                    </Col>
                </Row>
                <Row className="mt-2 justify-content-center align-items-center d-flex'">
                    <Form onSubmit={handleSubmit} as={Row} className='d-flex justify-content-center align-items-center'>
                        <Col sm={6}>
                            <div className="big-search-bar shadow-sm">
                                <input
                                    className="bsb-input"
                                    type="text"
                                    placeholder="Search..."
                                    onChange={(e) => setQuerySearch(e.target.value)}
                                />
                                <button className="bsb-search-btn" onClick={() => onSearch()}>
                                    <Search className="icon-cls" {...DFLT_ICO_PROPS} />
                                </button>
                            </div>
                        </Col>

                        <Row className='d-inline-flex justify-content-center align-items-center'>
                            <Col lg={2} sm={12} className='d-flex justify-content-center'>
                                <Form.Group as={Row} className="m-2 d-inline-flex w-100" controlId="formPlaintextEmail">
                                    <Form.Select value={selectedYear} onChange={handleYearChange}>
                                        <option defaultValue={""}>Year</option>
                                        {availableYears.map((year) => {
                                            return (
                                                <option 
                                                    key={year.label}
                                                    value={year.value}
                                                >
                                                    {year.label}
                                                </option>
                                            );
                                        })}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col lg={2} sm={12} className='d-flex justify-content-center'>
                                <Form.Group as={Row} className="m-2 d-inline-flex w-100" controlId="formPlaintextEmail">
                                    <Form.Select value={selectedMonth} onChange={handleMonthChange}>
                                        <option defaultValue={""}>Month</option>
                                        {availableMonths.map((month) => {
                                            return (
                                                <option 
                                                    key={month.label}
                                                    value={month.value}
                                                >
                                                    {month.label}
                                                </option>
                                            );
                                        })}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col lg={2} sm={12} className='d-flex justify-content-center'>
                                <Form.Group as={Row} className="m-2 d-inline-flex w-100" controlId="formPlaintextEmail">
                                    <Form.Select value={selectedDocumentType} onChange={handleDocumentTypeChange}>
                                        <option defaultValue={""}>Document Types</option>
                                        {documentTypes?.values?.map((type) => {
                                            return (
                                                <option 
                                                    key={type.constant}
                                                    value={type.constant}
                                                >
                                                    {type.value}
                                                </option>
                                            );
                                        })}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>
                    </Form>
                </Row>
                <Row className="mt-5">
                    <Col lg={6}>
                        <h4>{T('DRIVE_FEXPLORER_TITLE_FILE_EXPLORER')}</h4>
                        <Card className="shadow-sm p-0">
                            <Card.Body className="p-0">
                                <FileExplorer
                                    isLoading={isLoading}
                                    items={Object.values(searchResult)}
                                    fileSelected={currentFile}
                                    onSelectFile={onSelectFile}
                                    searchMode
                                />
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col lg={6}>
                        <h4>{T('DRIVE_FEXPLORER_TITLE_DETAILS')}</h4>
                        <Card className="shadow-sm">
                            <Card.Body className="p-0">
                                <AppTab
                                    afterTabs={currentFile ? (
                                        <>
                                            <Button
                                                onClick={handleDownloadFile}
                                            >{T('GEN_DOWNLOAD')}</Button>
                                        </>
                                    ) : null}
                                >
                                    <AppTab.Item label={T('DRIVE_FEXPLORER_TITLE_PREVIEW')}>
                                        <div className="text-center">
                                            <FilePreview
                                                fileElement={currentFile}
                                                fallback={() => <img src={FolderPictureURL} height={310} />}
                                            />
                                        </div>
                                    </AppTab.Item>
                                    <AppTab.Item label={T('DRIVE_DETAILS_COMMENTS')} disabled={!currentFile}>
                                        <FileComments
                                            onSendComment={onSendComment}
                                            fileElement={currentFile}
                                            fallback={() => <div className="text-center p-5"><img src={CommentFallbackURL} height={310} /></div>}
                                        />
                                    </AppTab.Item>
                                    <AppTab.Item label={T('DRIVE_DETAILS_INFORMATION')} disabled={!currentFile}>
                                        <FileInformation
                                            fileElement={currentFile}
                                            fallback={() => <div className="text-center"><img src={InformationFallbackURL} height={390} /></div>}
                                        />
                                    </AppTab.Item>
                                </AppTab>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </MainLayout>
    );
};

export default FileSearch;
